import React from 'react';

import { useFormikContext } from 'formik';

import SectionList from 'components/practice/UserPreferences/components/SectionList';
import Divider from 'components/shared/Divider/Divider';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Switch from 'components/shared/Switch/Switch';

const AutomationSettings = () => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <SectionList
      title="Automation"
      description="Configure automatic task creation for key workflows.">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <Switch
            checked={values?.displaySettings?.automation?.insurance_profile_review}
            onChange={(checked) =>
              setFieldValue('displaySettings.automation.insurance_profile_review', checked)
            }
            id="auto-insurance-profile-review-switch"
          />
          <label
            htmlFor="auto-insurance-profile-review-switch"
            className="text-sm font-400 text-neutral-900">
            Automatically create tasks for insurance profile review
          </label>
        </div>

        <Divider />

        <div className="flex items-center gap-2">
          <Switch
            checked={values?.displaySettings?.automation?.overdue_claims}
            onChange={(checked) =>
              setFieldValue('displaySettings.automation.overdue_claims', checked)
            }
            id="auto-overdue-claims-switch"
          />
          <label htmlFor="auto-overdue-claims-switch" className="text-sm font-400 text-neutral-900">
            Automatically create tasks for overdue claims
          </label>
        </div>
      </div>
    </SectionList>
  );
};

export default withErrorBoundary(AutomationSettings);
